import { ProductRules } from '@agroone/business'
import { UserPermissions } from '@agroone/entities'
import { environment } from '@front-app-environments/environment'

export interface NavItem {
  labelKey: string
  route: string
  icon: string
  permissions?: UserPermissions[]
}

export interface NavSection {
  labelKey: string
  items: NavItem[]
}

export const NAV_SECTIONS: NavSection[] = [
  {
    labelKey: 'MASTERDATA.NAV.SECTIONS.GLOBAL_REFERENTIALS',
    items: [
      {
        labelKey: 'MASTERDATA.NAV.CONSTANTS',
        route: '/constants',
        icon: 'settings',
        permissions: [UserPermissions.MASTERDATA_MANAGER],
      },
      {
        labelKey: 'MASTERDATA.NAV.CROP_TYPES',
        route: '/crop-types',
        icon: 'sprout',
        permissions: [UserPermissions.MASTERDATA_MANAGER],
      },
      {
        labelKey: 'MASTERDATA.NAV.COUNTRIES',
        route: '/countries',
        icon: 'globe',
        permissions: [UserPermissions.MASTERDATA_MANAGER],
      },
    ],
  },
  {
    labelKey: 'MASTERDATA.NAV.SECTIONS.BUSINESS_REFERENTIALS',
    items: [
      {
        labelKey: 'MASTERDATA.NAV.CAMPAIGNS',
        route: '/campaigns',
        icon: 'calendar',
        permissions: [UserPermissions.MASTERDATA_MANAGER],
      },
      {
        labelKey: 'MASTERDATA.NAV.VARIETIES',
        route: '/varieties',
        icon: 'leaf',
        permissions: [UserPermissions.MASTERDATA_MANAGER],
      },
      {
        labelKey: 'MASTERDATA.NAV.NUTRIENTS',
        route: '/nutrients',
        icon: 'droplets',
        permissions: [UserPermissions.MASTERDATA_MANAGER],
      },
      {
        labelKey: 'MASTERDATA.NAV.LABORATORIES',
        route: '/laboratories',
        icon: 'flask',
        permissions: [UserPermissions.MASTERDATA_MANAGER],
      },
    ],
  },
  {
    labelKey: 'MASTERDATA.NAV.SECTIONS.BUSINESS_SETTINGS',
    items: [
      {
        labelKey: 'MASTERDATA.NAV.ALERT_SETTINGS',
        route: '/alert-settings',
        icon: 'bell',
        permissions: [UserPermissions.MASTERDATA_MANAGER],
      },
      {
        labelKey: 'MASTERDATA.NAV.ANOMALIES',
        route: '/anomalies',
        icon: 'alert-triangle',
        permissions: [UserPermissions.MASTERDATA_SPECIFICATION],
      },
      {
        labelKey: 'MASTERDATA.NAV.CSR_SETTINGS',
        route: '/csr-settings',
        icon: 'shield',
        permissions: [UserPermissions.MASTERDATA_CSR_EDITION],
      },
    ],
  },
  {
    labelKey: 'MASTERDATA.NAV.SECTIONS.CONTROL_COMPLIANCE',
    items: [
      {
        labelKey: 'MASTERDATA.NAV.SPECIFICATIONS',
        route: '/specifications',
        icon: 'file-text',
        permissions: [UserPermissions.MASTERDATA_SPECIFICATION],
      },
      {
        labelKey: 'MASTERDATA.NAV.HOMOLOGA',
        route: '/homologa',
        icon: 'clipboard',
        permissions: [UserPermissions.MASTERDATA_SPECIFICATION],
      },
    ],
  },
  ...(ProductRules.isV2Available(environment.envName)
    ? [
        {
          labelKey: 'MASTERDATA.NAV.SECTIONS.CONTROL_COMPLIANCE_V2',
          items: [
            {
              labelKey: 'MASTERDATA.PRODUCTS_V2.TITLE',
              route: '/control-compliance-v2/products',
              icon: 'clipboard',
              permissions: [UserPermissions.MASTERDATA_MODULE_ACCESS],
            },
            {
              labelKey: 'MASTERDATA.NAV.SPECIFICATIONS',
              route: '/control-compliance-v2/specifications',
              icon: 'file-text',
              permissions: [UserPermissions.MASTERDATA_MODULE_ACCESS],
            },
            {
              labelKey: 'MASTERDATA.NAV.INGREDIENTS',
              route: '/control-compliance-v2/ingredients',
              icon: 'flask',
              permissions: [UserPermissions.MASTERDATA_MODULE_ACCESS],
            },
          ],
        },
      ]
    : []),
  {
    labelKey: 'MASTERDATA.NAV.SECTIONS.USER',
    items: [
      {
        labelKey: 'MASTERDATA.NAV.USER_PREFERENCES',
        route: '/user-preferences',
        icon: 'user',
        permissions: [UserPermissions.CROP_MODULE_ACCESS],
      },
    ],
  },
]

export const NAV_ITEMS = NAV_SECTIONS.flatMap((section) => section.items)
